import { render, staticRenderFns } from "./Createemailtemplate.vue?vue&type=template&id=9f4b7e72&"
import script from "./Createemailtemplate.vue?vue&type=script&lang=js&"
export * from "./Createemailtemplate.vue?vue&type=script&lang=js&"
import style0 from "./Createemailtemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports